import React, { useEffect, useState } from 'react';
import api from '../../utils/axiosInstance';
import AdminSideMenu from '../../components/AdminSideMenu';

const Specialpackagesubscribedcarriers = () => {
    const [subscribedCarriers, setSubscribedCarriers] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total pages
    const itemsPerPage = 6; // Carriers per page

    // ------------------ FETCH CARRIERS ------------------
    const fetchCarriers = async (page = 1) => {
        try {
            setLoading(true);
            const res = await api.get(`/special-package/admin/carriers?page=${page}&limit=${itemsPerPage}`);
            const data = res.data;

            if (data.success && Array.isArray(data.carriers)) {
                // Map carriers: combine subscription info with carrier info
                const mapped = data.carriers.map((item) => ({
                    ...item.carrier, // actual carrier fields
                    subscriptionStatus: item.status,
                    startDate: item.startDate,
                    endDate: item.endDate,
                    pricePaid: item.pricePaid,
                    autoPayment: item.autoPayment,
                    isActiveNow: item.isActiveNow,
                }));

                setSubscribedCarriers(mapped);
                console.log('set', mapped);
                setTotalPages(Math.ceil(mapped.length / itemsPerPage)); // fallback pagination
            } else {
                setSubscribedCarriers([]);
            }

            setCurrentPage(page);
        } catch (err) {
            console.error('Failed to fetch carriers:', err);
            setError('Failed to load carriers');
        } finally {
            setLoading(false);
        }
    };

    // ------------------ ON MOUNT ------------------
    useEffect(() => {
        fetchCarriers(1);
    }, []);

    return (
        <div className='flex flex-col md:flex-row'>
            <AdminSideMenu />
            <div className='md:ml-64 p-4 md:p-8 w-full bg-gray-50 min-h-screen'>
                <header className='pb-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <div>
                        <h1 className='text-2xl md:text-3xl font-bold text-gray-900'>Subscribed Carriers</h1>
                    </div>
                </header>

                {loading && <div className='text-center py-10 text-gray-500'>Loading carriers...</div>}
                {error && <div className='text-center py-10 text-red-500'>{error}</div>}

                {/* ------------------ GRID ------------------ */}
                {!loading && !error && (
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
                        {subscribedCarriers.length === 0 ? (
                            <div className='col-span-full text-center text-gray-500 text-lg py-12'>
                                No carriers found
                            </div>
                        ) : (
                            subscribedCarriers.map((carrier) => (
                                <div
                                    key={carrier._id}
                                    className='bg-white p-6 rounded-xl shadow border border-l-4 border-l-blue-600'
                                >
                                    {/* Top Section (Logo + Name) */}
                                    <div className='flex items-center gap-4 mb-4'>
                                        <img
                                            src={
                                                carrier.companyLogo
                                                    ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${carrier.companyLogo}`
                                                    : '/assets/dummy-icon.jpeg'
                                            }
                                            alt='Company Logo'
                                            className='w-12 h-12 rounded-full object-cover'
                                        />
                                        <div>
                                            <h3 className='text-lg font-bold break-words'>{carrier.companyName}</h3>
                                            <span
                                                className={`text-xs font-medium ${carrier.subscriptionStatus === 'Active' ? 'text-green-600' : 'text-blue-600'}`}
                                            >
                                                {carrier.subscriptionStatus}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Carrier Details */}
                                    <div className='text-sm space-y-1'>
                                        <p>
                                            <strong>Fleety ID:</strong> {carrier.identificationNumber || 'N/A'}
                                        </p>

                                        <p className='break-all'>
                                            <strong>Email:</strong> {carrier.email || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>Phone:</strong> {carrier.phone || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>City:</strong> {carrier.city || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>State:</strong> {carrier.state || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>ZIP:</strong> {carrier.zip || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>Subscribed Date:</strong>{' '}
                                            {carrier.startDate
                                                ? new Date(carrier.startDate).toLocaleDateString('en-US')
                                                : 'N/A'}
                                        </p>
                                        <p>
                                            <strong>Auto Payment:</strong>{' '}
                                            <span
                                                className={`px-2 py-0.5 rounded text-xs font-semibold ${
                                                    carrier.autoPayment
                                                        ? 'bg-green-100 text-green-700'
                                                        : 'bg-red-100 text-red-600'
                                                }`}
                                            >
                                                {carrier.autoPayment ? 'Enabled' : 'Disabled'}
                                            </span>
                                        </p>

                                        <p>
                                            <strong>Joined:</strong>{' '}
                                            {carrier.createdAt
                                                ? new Date(carrier.createdAt).toLocaleDateString('en-US')
                                                : 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Specialpackagesubscribedcarriers;
